// extracted by mini-css-extract-plugin
export var form = "form-module--form--8c367";
export var formSidebar = "form-module--formSidebar--27e7f";